module.exports = __webpack_public_path__ + "assets/img/home-box1-sandbox-light.33949077.png";